import React from 'react';
import { ICourseIcon, ICourseIconProps } from './CourseIcon';

export const GraduationCapIcon: ICourseIcon = React.forwardRef<SVGSVGElement, ICourseIconProps>((props, ref) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
      <g clipPath="url(#clip0_233_3247)">
      <path d="M5.97656 5.34374L0.726562 3.375L5.97656 1.35938L11.2734 3.375L5.97656 5.34374Z" stroke="black" strokeWidth="0.75" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.16406 4.17188V6.70312C7.05469 8.01562 4.94531 8.01562 2.83594 6.70312V4.17188" stroke="black" strokeWidth="0.75" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.57031 3.70312V8.01562" stroke="black" strokeWidth="0.75" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.41406 8.85938C2.41406 8.39062 2.03906 8.01562 1.57031 8.01562C1.10156 8.01562 0.726562 8.39062 0.726562 8.85938V10.6406H2.41406V8.85938Z" stroke="black" strokeWidth="0.75" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_233_3247">
      <rect width="12" height="12" fill="white"/>
      </clipPath>
      </defs>
  </svg>

));

GraduationCapIcon.displayName = 'GraduationCapIcon';
